// extracted by mini-css-extract-plugin
module.exports = {"root":"FlagControl_root__3FpJC","active":"FlagControl_active__PVZQM"};